var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { log } from "../../utils";
import { Cursor } from "../events/cursor";
import { Input } from "../events/input";
import { Scroll } from "../events/scroll";
import { COBROWSER_PERMISSION, FilterType, } from "../../model";
import { Users } from "../../users";
import { namespaces } from "../capture/serializer";
import { PageBase } from "./base";
import { Walker } from "../walker";
import { getAttachment } from "../attachment";
import { Transparent1px, randomizeText } from "../capture/filter";
import { Gzip } from "../compression/native";
import { Zstd } from "../compression/zstd";
import { Sheet } from "../events/sheet";
import { HighLighter } from "../events/highlight";
export class MirrorPage extends PageBase {
    constructor(options, parent = null, handlers = {}, root) {
        var _a, _b, _c, _d;
        var _e;
        super(options.target, parent, options.user);
        this.options = options;
        this.parent = parent;
        this.handlers = handlers;
        this.root = root;
        this.isOwner = false;
        this.url = {};
        this.pendingFilteredNodes = [];
        this.pendingDialogNodes = [];
        // eslint-disable-next-line no-use-before-define
        this.frames = [];
        // eslint-disable-next-line no-use-before-define
        this.docs = {};
        this.remoteTimeInit = Date.now();
        this.localTimeInit = Date.now();
        this.canUpdate = false;
        this.isLive = true;
        /** id: base64 of binary data */
        this.attachments = {};
        /** moved nodes no longer synced, workaround for latest version */
        this.postProcessMovedNodes = [];
        this.pendingInserts = [];
        /** some tags that look like custom elements will have invalid name, do not define them */
        this.ignoreTags = new Set();
        (_a = (_e = this.options).compressionSupport) !== null && _a !== void 0 ? _a : (_e.compressionSupport = {
            zstd: {
                compress: false,
                decompress: false,
            },
            gzip: {
                compress: false,
                decompress: false,
            },
        });
        (_b = options.ignorePermissions) !== null && _b !== void 0 ? _b : (options.ignorePermissions = false);
        this.isLive = ((_c = this.parent) === null || _c === void 0 ? void 0 : _c.isLive) || !(this.options.isLive === false);
        this.users = ((_d = this.parent) === null || _d === void 0 ? void 0 : _d.users) || new Users();
        if (this.isRoot) {
            this.users = new Users();
            this.root = this;
        }
        else {
            this.users = this.parent.users;
        }
        this.input = new Input(this, (ev) => this.appendQueue("InputUpdate", ev));
        this.cursor = new Cursor(this, (ev) => this.appendQueue("Cursor", ev));
        this.scroll = new Scroll(this, (ev) => this.appendQueue("ScrollUpdate", ev));
        this.highlighter = new HighLighter(this, (ev) => this.appendQueue("HighLight", ev));
        this.sheet = new Sheet(this, () => { });
    }
    static create(...args) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const target = args[0].target;
            if (((_a = target.contentDocument) === null || _a === void 0 ? void 0 : _a.readyState) !== "complete") {
                yield new Promise((resolve) => target.addEventListener("load", resolve, { once: true }));
                if (!target.isConnected) {
                    return;
                }
            }
            return new MirrorPage(...args);
        });
    }
    getTime() {
        // time relative to peer's first event time
        return Date.now() - this.root.localTimeInit + this.root.remoteTimeInit;
    }
    appendQueue(type, payload) {
        if (this.root.canUpdate) {
            this.queue.push(this.event(type, payload));
        }
    }
    requestAbsolutePosition() {
        var _a;
        if (this.isRoot) {
            const coords = { left: 0, top: 0 };
            this.forEachFrame((frame) => frame.resetAbsolutePosition(coords));
        }
        else {
            (_a = this.root) === null || _a === void 0 ? void 0 : _a.requestAbsolutePosition();
        }
    }
    resetAbsolutePosition(coords) {
        const rect = this.target.getBoundingClientRect();
        this.absoluteLeft = coords.left + rect.left;
        this.absoluteTop = coords.top + rect.top;
        this.forEachFrame((frame) => frame.resetAbsolutePosition({
            left: this.absoluteLeft,
            top: this.absoluteTop,
        }));
    }
    transformObserver(event) {
        const documentId = event.document || 1;
        const createEvent = (type, payload) => ({
            type,
            payload,
            time: event.time,
            endpoint: event.user.endpoint,
            document: documentId,
        });
        const mutations = {
            attributes: {},
            nodes: { insert: [], remove: [] },
            values: {},
        };
        const updates = [
            createEvent("Mutations", mutations),
        ];
        const fragments = mutations.nodes.insert;
        const records = event.payload.records;
        const isDomOp = (type) => type === "insert" || type === "move" || type === "filter";
        const isFragmentTop = (rec) => !(rec.parent in records && isDomOp(records[rec.parent].type));
        const isTopEdge = (rec) => !(rec.previousSibling in records &&
            isDomOp(records[rec.previousSibling].type));
        for (const id in records) {
            const record = records[id];
            switch (record.type) {
                case "attr":
                    mutations.attributes[record.nid] = record.attrs;
                    break;
                case "move":
                    this.postProcessMovedNodes.push(this.idp.getNode(record.nid));
                // eslint-disable-next-line no-fallthrough
                case "filter":
                case "insert": {
                    if (isTopEdge(record)) {
                        let iter = record;
                        const siblings = [iter.nid];
                        for (; iter.nextSibling in records; iter = records[iter.nextSibling]) {
                            siblings.push(iter.nextSibling);
                        }
                        if (isFragmentTop(record)) {
                            fragments.push({
                                nodes: {},
                                tree: siblings,
                                parent: record.parent,
                                next: iter.nextSibling,
                                previous: record.previousSibling,
                            });
                        }
                        else if (isTopEdge(record)) {
                            records[record.parent].children = siblings;
                        }
                    }
                    break;
                }
                case "remove":
                    mutations.nodes.remove.push(record.nid);
                    break;
                case "text":
                    mutations.values[record.nid] = record.value;
                    break;
            }
        }
        const dfs = (id, frag) => {
            var _a;
            const record = records[id];
            switch (record.type) {
                case "filter":
                    frag.nodes[record.nid] = {
                        id: record.nid,
                        name: "DIV",
                        attrs: record.attrs,
                        filter: record.display ? FilterType.Display : FilterType.NoDisplay,
                    };
                    break;
                case "insert":
                    frag.nodes[record.nid] = {
                        id: record.nid,
                        name: record.node.name ||
                            (record.node.type === 3 ? "#text" : "#comment"),
                        // @ts-expect-error
                        ns: record.node.ns || "html",
                        attrs: record.node.attrs,
                        text: record.node.data,
                        sheet: record.node.name === "STYLE"
                            ? { rules: record.node.data }
                            : undefined,
                    };
                    if (typeof record.node.data === "object") {
                        updates.push(createEvent("InputUpdate", record.node.data.selected
                            ? {
                                target: record.parent,
                                init: true,
                                selected: [record.nid],
                            }
                            : {
                                target: record.nid,
                                init: true,
                                checked: record.node.data.checked,
                                value: record.node.data.value,
                            }));
                    }
                    break;
                case "move":
                    frag.nodes[record.nid] = { id: record.nid, name: "#comment" };
                    break;
            }
            return ((_a = record.children) === null || _a === void 0 ? void 0 : _a.length)
                ? [record.nid].concat(record.children.map((id) => dfs(id, frag)))
                : record.nid;
        };
        for (const frag of fragments) {
            frag.tree = frag.tree.map((id) => dfs(id, frag));
        }
        return updates;
    }
    /** transform a Tree Instance event to latest version events */
    transformTreeInstance(event) {
        var _a, _b;
        const documentId = event.document || 1;
        const documentElementId = event.payload.documentElement || 2;
        const headId = event.payload.head || 3;
        const bodyId = event.payload.body || 4;
        const createEvent = (type, payload, docId = documentId) => ({
            type,
            payload,
            time: event.time,
            endpoint: event.user.endpoint,
            document: docId,
        });
        const updates = [
            createEvent("Document", {
                id: documentId,
                target: event.payload.target || 0,
            }, ((_b = (_a = this.getPageByFrame(this.idp.getNode(event.payload.target || 0))) === null || _a === void 0 ? void 0 : _a.parent) === null || _b === void 0 ? void 0 : _b.documentId) || documentId),
            createEvent("Navigation", Object.assign({ synthetic: true }, event.payload.url)),
            ...this.transformObserver({
                time: event.time,
                type: "Observer",
                document: documentId,
                user: event.user,
                payload: {
                    records: Object.assign(Object.assign({}, event.payload.records), { [documentElementId]: {
                            type: "insert",
                            nid: documentElementId,
                            node: {
                                nid: documentElementId,
                                name: "HTML",
                                type: 1,
                                attrs: event.payload.records[documentElementId].attrs,
                            },
                            parent: documentId,
                            nextSibling: 0,
                            previousSibling: 0,
                        }, [headId]: {
                            type: "insert",
                            nid: headId,
                            node: {
                                nid: headId,
                                name: "HEAD",
                                type: 1,
                                attrs: event.payload.records[headId]
                                    .attrs,
                            },
                            parent: documentElementId,
                            nextSibling: bodyId,
                            previousSibling: 0,
                        }, [bodyId]: {
                            type: "insert",
                            nid: bodyId,
                            node: {
                                nid: bodyId,
                                name: "BODY",
                                type: 1,
                                attrs: event.payload.records[bodyId]
                                    .attrs,
                            },
                            parent: documentElementId,
                            nextSibling: 0,
                            previousSibling: headId,
                        } }),
                },
            }),
        ];
        if (event.payload.scroll) {
            updates.push(createEvent("ScrollUpdate", Object.assign({ init: true }, event.payload.scroll)));
        }
        return updates;
    }
    compatibilityTransformV1(event) {
        const createEvent = (type, payload) => ({
            type,
            payload,
            time: event.time,
            endpoint: event.user.endpoint,
            document: 1,
        });
        switch (event.type) {
            case "Batch":
                return [
                    createEvent("Batch", {
                        format: "json",
                        events: event.payload.events.flatMap((e) => this.compatibilityTransformV1(e)),
                    }),
                ];
            case "Cursor":
                return [
                    createEvent("Cursor", event.payload),
                ];
            case "HrefUpdate":
                return [
                    createEvent("Navigation", {
                        href: event.payload.href,
                        base: this.url.base || "",
                    }),
                ];
            case "InputUpdate":
                return [createEvent("InputUpdate", event.payload)];
            case "Observer":
                return this.transformObserver(event);
            case "PageMetadata":
                return [createEvent("PageMetadata", event.payload)];
            case "ResizeUpdate":
                return [createEvent("ResizeUpdate", event.payload)];
            case "ScrollUpdate":
                return [createEvent("ScrollUpdate", event.payload)];
            case "TreeInstance":
                return this.transformTreeInstance(event);
        }
    }
    compatibilityTransformV2(event) {
        const createEvent = (type, payload) => ({
            type,
            payload,
            time: event.time,
            endpoint: event.user.endpoint,
            document: event.document,
        });
        switch (event.type) {
            case "Batch":
                return [
                    createEvent("Batch", {
                        format: "json",
                        events: event.payload.events.flatMap((e) => this.compatibilityTransformV2(e)),
                    }),
                ];
            case "Cursor":
                return [
                    createEvent("Cursor", event.payload),
                ];
            case "HrefUpdate":
                return [
                    createEvent("Navigation", {
                        href: event.payload.href,
                        base: this.url.base || "",
                    }),
                ];
            case "InputUpdate":
                return [createEvent("InputUpdate", event.payload)];
            case "Observer":
                return this.transformObserver(event);
            case "PageMetadata":
                return [createEvent("PageMetadata", event.payload)];
            case "ResizeUpdate":
                return [createEvent("ResizeUpdate", event.payload)];
            case "ScrollUpdate":
                return [createEvent("ScrollUpdate", event.payload)];
            case "TreeInstance":
                return this.transformTreeInstance(event);
            case "FrameClosed":
                return [createEvent("FrameClosed", undefined)];
            default:
                return [];
        }
    }
    renderV1(ev) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const event of this.compatibilityTransformV1(ev)) {
                yield this.renderV3(event);
            }
            this.oldPostRender();
        });
    }
    renderV2(ev) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const event of this.compatibilityTransformV2(ev)) {
                yield this.renderV3(event);
            }
            this.oldPostRender();
        });
    }
    isEventV3(ev) {
        return "endpoint" in ev;
    }
    isEventV2(ev) {
        return "document" in ev;
    }
    render(ev) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isEventV3(ev)) {
                yield this.renderV3(ev);
                this.postRender();
            }
            else if (this.isEventV2(ev)) {
                yield this.renderV2(ev);
            }
            else {
                yield this.renderV1(ev);
            }
        });
    }
    oldPostRender() {
        if (this.postProcessMovedNodes.length) {
            // replace temp nodes with the ones that should be moved
            this.postProcessMovedNodes.forEach((node) => {
                var _a;
                if (node) {
                    (_a = this.idp.getNode(getAttachment(node).id)) === null || _a === void 0 ? void 0 : _a.replaceWith(node);
                }
            });
            this.postProcessMovedNodes = [];
        }
    }
    renderV3(ev) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e;
            const userId = this.users.getId(ev.endpoint);
            const page = this.docs[ev.document] || (ev.document <= 1 ? this : null);
            switch (ev.type) {
                case "Batch":
                    yield this.handleRemoteBatch(ev);
                    break;
                case "InputUpdate":
                    if (this.users.hasPermission(userId, COBROWSER_PERMISSION.CONTROL)) {
                        page.handleRemoteInput(ev);
                    }
                    break;
                case "ScrollUpdate":
                    page.handleRemoteScroll(ev);
                    break;
                case "Cursor":
                    if (ev.payload.type === "mousemove") {
                        page.handleRemoteCursor(ev);
                        (_b = (_a = this.handlers)[ev.payload.type]) === null || _b === void 0 ? void 0 : _b.call(_a, {
                            left: ev.payload.clientX,
                            top: ev.payload.clientY,
                            type: ev.payload.type,
                            user: { id: userId, endpoint: ev.endpoint },
                        });
                    }
                    else if (this.users.hasPermission(userId, COBROWSER_PERMISSION.CONTROL)) {
                        page.handleRemoteCursor(ev);
                    }
                    break;
                case "PageMetadata":
                    if (ev.payload.type === "UserInfo") {
                        this.users.addUser({ id: ev.payload.data.id, endpoint: ev.payload.data.endpoint }, null, ev.payload.data.metadata);
                    }
                    if (this.options.ignorePermissions) {
                        this.users.setPermission(ev.payload.data.id, COBROWSER_PERMISSION.CONTROL);
                        this.users.setPermission(ev.payload.data.id, COBROWSER_PERMISSION.VIEW);
                    }
                    this.remoteTimeInit = ev.time;
                    // very rough estimate but good enough
                    this.localTimeInit = Date.now() - 400;
                    this.canUpdate = this.isLive;
                    this.appendQueue("PageMetadata", {
                        type: "UserInfo",
                        data: {
                            endpoint: (_c = this.options.user) === null || _c === void 0 ? void 0 : _c.endpoint,
                            id: (_d = this.options.user) === null || _d === void 0 ? void 0 : _d.id,
                            metadata: (_e = this.options.user) === null || _e === void 0 ? void 0 : _e.metadata,
                        },
                    });
                    break;
                case "ResizeUpdate":
                    page.handleRemoteResize(ev);
                    break;
                case "Document": {
                    const pg = yield page.handleDocument(ev);
                    if (pg) {
                        this.docs[pg.documentId] = pg;
                    }
                    break;
                }
                case "Navigation":
                    page.handleRemoteNavigation(ev);
                    break;
                case "Mutations":
                    page.handleMutations(ev);
                    break;
                case "MutationList":
                    page.handleMutationList(ev);
                    break;
                case "StyleSheet":
                    yield page.handleStyleSheet(ev);
                    break;
                case "CanvasImage":
                    page.handleCanvasImage(ev);
                    break;
                case "Attachment":
                    this.attachments[ev.payload.id] = ev.payload.data;
                    break;
                case "SheetUpdate":
                    yield page.sheet.dispatch(ev.payload);
                    break;
                case "HighLight":
                    yield page.highlighter.dispatch(ev.payload);
                    break;
            }
        });
    }
    /** v3 merge events */
    *mergeEvents(events) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var _j, _k, _l;
        const documents = {};
        // const mEvents: PageUpdateV3[] = [];
        const lastMouseMoves = {};
        for (let i = 0; i < events.length; i++) {
            const event = events[i];
            (_a = documents[_j = event.document]) !== null && _a !== void 0 ? _a : (documents[_j] = {
                documents: {},
                attachments: {},
                mutations: null,
                navigation: null,
                input: {},
                scroll: {},
                canvas: {},
                styles: {},
                sheet: [],
                highlight: null,
            });
            switch (event.type) {
                case "Cursor":
                    if (event.payload.type === "mousemove") {
                        lastMouseMoves[event.endpoint] = event;
                    }
                    break;
                case "Document":
                    // target iframe is being reset, remove all previous events
                    if (documents[event.document].documents[event.payload.target]) {
                        delete documents[documents[event.document].documents[event.payload.target].payload
                            .id];
                        (_b = documents[_k = event.document]) !== null && _b !== void 0 ? _b : (documents[_k] = {
                            documents: {},
                            attachments: {},
                            mutations: null,
                            navigation: null,
                            input: {},
                            scroll: {},
                            canvas: {},
                            styles: {},
                            sheet: [],
                            highlight: null,
                        });
                    }
                    documents[event.document].documents[event.payload.target] = event;
                    break;
                case "Mutations":
                    (_c = (_l = documents[event.document]).mutations) !== null && _c !== void 0 ? _c : (_l.mutations = {
                        type: "MutationList",
                        time: event.time,
                        document: event.document,
                        endpoint: event.endpoint,
                        payload: [],
                    });
                    documents[event.document].mutations.payload.push(event);
                    break;
                case "InputUpdate":
                    documents[event.document].input[event.payload.target] = event;
                    break;
                case "Navigation":
                    documents[event.document].navigation = event;
                    break;
                case "PageMetadata":
                case "ResizeUpdate":
                    yield event;
                    break;
                case "ScrollUpdate":
                    documents[event.document].scroll[event.payload.target] = event;
                    break;
                case "Attachment":
                    documents[event.document].attachments[event.payload.id] = event;
                    break;
                case "CanvasImage":
                    // remove any previous associated attachment
                    if ((_d = documents[event.document].canvas[event.payload.target]) === null || _d === void 0 ? void 0 : _d.payload.attachment) {
                        delete documents[event.document].attachments[documents[event.document].canvas[event.payload.target].payload
                            .attachment];
                    }
                    documents[event.document].canvas[event.payload.target] = event;
                    break;
                case "StyleSheet":
                    documents[event.document].styles[event.payload.target] = event;
                    break;
                case "FrameClosed":
                    delete documents[event.document];
                    break;
                case "SheetUpdate":
                    documents[event.document].sheet.push(event);
                    break;
                case "HighLight":
                    documents[event.document].highlight = event;
                    break;
                // these are ignored
                // case "MutationList":
                // case "SyncRequest":
                // case "Batch":
                //   break;
            }
        }
        // root doc should render first
        if ((_e = documents[1]) === null || _e === void 0 ? void 0 : _e.documents[0]) {
            yield documents[1].documents[0];
            delete documents[1].documents[0];
        }
        for (const docId of Object.keys(documents).sort((a, b) => +a - +b)) {
            if (!((_g = (_f = this.docs[docId]) === null || _f === void 0 ? void 0 : _f.target) === null || _g === void 0 ? void 0 : _g.isConnected)) {
                continue;
            }
            const events = documents[docId];
            if (events.navigation)
                yield events.navigation;
            if (events.mutations)
                yield events.mutations;
            for (const id in events.attachments)
                yield events.attachments[id];
            for (const id in events.styles)
                yield events.styles[id];
            for (const id in events.canvas)
                yield events.canvas[id];
            for (const id in events.input)
                yield events.input[id];
            if (events.highlight)
                yield events.highlight;
            (_h = this.docs[docId]) === null || _h === void 0 ? void 0 : _h.insertPendingFrags();
            // these events need the fragments to be connected
            for (const sheet of events.sheet)
                yield sheet;
            for (const id in events.scroll)
                yield events.scroll[id];
            for (const id in events.documents)
                yield events.documents[id];
        }
        for (const id in lastMouseMoves)
            yield lastMouseMoves[id];
    }
    handleRemoteBatch(_a) {
        return __awaiter(this, arguments, void 0, function* ({ payload }) {
            var _b;
            let error = null;
            if (!((_b = payload.events) === null || _b === void 0 ? void 0 : _b.length)) {
                return;
            }
            for (const e of this.mergeEvents(payload.events)) {
                try {
                    yield this.renderV3(e);
                }
                catch (ex) {
                    log(ex);
                    error !== null && error !== void 0 ? error : (error = ex);
                }
            }
            if (error)
                throw error;
        });
    }
    handleDocument(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            let page;
            const target = event.payload.target
                ? this.idp.getNode(event.payload.target)
                : this.target;
            if (!target || target.tagName !== "IFRAME") {
                console.log(JSON.stringify(event));
                throw new Error(`Cobrowser: Target ${event.payload.target}, in document ${event.document} is not an iframe.`);
            }
            if (event.payload.target) {
                target.setAttribute("sandbox", "allow-same-origin allow-scripts");
                if (!target.hasAttribute("srcdoc") &&
                    !((_a = target.getAttribute("src")) === null || _a === void 0 ? void 0 : _a.includes("/cobrowser/public/remote/"))) {
                    const onload = new Promise((resolve) => {
                        const timeout = setTimeout(resolve, 2000);
                        target.addEventListener("load", () => {
                            clearTimeout(timeout);
                            resolve();
                        }, { once: true });
                    });
                    target.setAttribute("src", new URL("/cobrowser/public/remote/" + event.payload.id, location.origin).toString());
                    yield onload;
                }
            }
            do {
                // wait for defaultView to be available
                yield new Promise((resolve) => setTimeout(resolve, 20));
                if (!target.isConnected) {
                    return;
                }
            } while (!((_b = target.contentDocument) === null || _b === void 0 ? void 0 : _b.defaultView));
            if (event.payload.target) {
                page = this.getPageByFrame(target);
                if (page) {
                    page.cleanup();
                    this.frames.filter((pg) => pg !== page);
                }
                page = new MirrorPage({
                    target,
                    user: this.options.user,
                    compressionSupport: this.options.compressionSupport,
                }, this, this.handlers, this.root);
                page.setEvents({
                    input: this.input.enabled || undefined,
                    scroll: this.scroll.enabled || undefined,
                    cursor: this.cursor.enabled || undefined,
                    highlight: this.highlighter.enabled || undefined,
                });
                this.frames.push(page);
            }
            else {
                page = this;
                this.forEachFrame((pg) => pg.cleanup());
                this.frames = [];
                this.cleanIdp();
            }
            page.documentId = event.payload.id;
            return page;
        });
    }
    // TODO: remove unused documents
    removeDocument(id) {
        const ipg = this.frames.findIndex((pg) => pg.documentId === id);
        if (ipg !== -1) {
            this.frames.splice(ipg, 1);
        }
        if (this.isRoot) {
            delete this.docs[id];
        }
        else {
            this.parent.removeDocument(id);
        }
    }
    postRender() {
        var _a, _b;
        if (this.pendingFilteredNodes.length) {
            (_b = (_a = this.handlers).filtered) === null || _b === void 0 ? void 0 : _b.call(_a, {
                nodes: this.pendingFilteredNodes,
                filters: this.pendingFilteredNodes.map((n) => getAttachment(n).filter),
            });
            this.pendingFilteredNodes = [];
        }
        if (this.pendingDialogNodes.length) {
            for (const dialog of this.pendingDialogNodes) {
                if (dialog.open) {
                    dialog.close();
                    dialog.showModal();
                }
                else {
                    dialog.close();
                }
            }
            this.pendingDialogNodes = [];
        }
    }
    insertFragment(parent, fragment, next) {
        var _a;
        if (parent.nodeType === parent.DOCUMENT_NODE) {
            // documentElement might have already been removed by previous mutations list
            (_a = parent.documentElement) === null || _a === void 0 ? void 0 : _a.remove();
        }
        try {
            parent.insertBefore(fragment, this.idp.getNode(next));
        }
        catch (ex) {
            console.error(ex, fragment, this);
        }
        // if document was re-inserted, reset some events listeners
        if (parent.nodeType === parent.DOCUMENT_NODE) {
            this.highlighter.track();
        }
    }
    insertPendingFrags() {
        for (const frag of this.pendingInserts) {
            if (frag) {
                this.insertFragment(...frag);
            }
        }
        this.pendingInserts = [];
    }
    handleMutationList(event) {
        var _a, _b, _c, _d;
        const removed = new Set();
        // remove subtree of all removed nodes and keep the ids in a set
        for (const mut of event.payload) {
            if ((_a = mut.payload.nodes) === null || _a === void 0 ? void 0 : _a.remove.length) {
                for (const id of mut.payload.nodes.remove) {
                    const node = this.idp.getNode(id);
                    if (node) {
                        if (node.childNodes.length) {
                            new Walker(node).sprint((n) => this.idp.removeNode(n));
                        }
                        const comment = this.getDocument().createComment("");
                        this.idp.set(comment, id);
                        node.parentNode.replaceChild(comment, node);
                    }
                    removed.add(id);
                }
            }
        }
        const attributes = {};
        const styles = {};
        const values = {};
        const iframe = {};
        for (const mut of event.payload) {
            if ((_b = mut.payload.nodes) === null || _b === void 0 ? void 0 : _b.insert) {
                for (const frag of mut.payload.nodes.insert) {
                    this.pendingInserts.push(this.createFragment(frag));
                }
            }
            if (mut.payload.iframe) {
                for (const id in mut.payload.iframe) {
                    if (!removed.has(+id) && this.idp.getNode(+id)) {
                        iframe[id] = mut.payload.iframe[id];
                    }
                }
            }
            if (mut.payload.attributes) {
                for (const id in mut.payload.attributes) {
                    if (!removed.has(+id) && this.idp.getNode(+id)) {
                        (_c = attributes[id]) !== null && _c !== void 0 ? _c : (attributes[id] = {});
                        attributes[id] = Object.assign(Object.assign({}, attributes[id]), mut.payload.attributes[id]);
                    }
                }
            }
            if (mut.payload.styles) {
                for (const id in mut.payload.styles) {
                    if (!removed.has(+id) && this.idp.getNode(+id)) {
                        (_d = styles[id]) !== null && _d !== void 0 ? _d : (styles[id] = {});
                        styles[id] = Object.assign(Object.assign({}, styles[id]), mut.payload.styles[id]);
                    }
                }
            }
            if (mut.payload.values) {
                for (const id in mut.payload.values) {
                    if (!removed.has(+id) && this.idp.getNode(+id)) {
                        values[id] = mut.payload.values[id];
                    }
                }
            }
        }
        this.handleMutations(Object.assign(Object.assign({}, event), { type: "Mutations", payload: {
                nodes: { remove: Array.from(removed), insert: [] },
                attributes,
                values,
                styles,
            } }));
    }
    popAttachment(id) {
        if (id in this.root.attachments) {
            const att = this.root.attachments[id];
            delete this.root.attachments[id];
            return att;
        }
        else {
            return null;
        }
    }
    handleStyleSheet(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const elm = this.idp.getNode(event.payload.target);
            if (event.payload.format === "pointer") {
                const sheet = this.sheetIds[event.payload.id];
                if (sheet) {
                    elm.adoptedStyleSheets.push(sheet);
                }
                return;
            }
            let rules = this.popAttachment(event.payload.attachment) || event.payload.rules;
            if (event.payload.format === "gzip") {
                rules = yield Gzip.decompress(rules);
            }
            else if (event.payload.format === "zstd") {
                rules = yield Zstd.decompress(rules);
            }
            if (elm && rules) {
                // check if it is a shadow root
                if (elm.nodeType === document.DOCUMENT_FRAGMENT_NODE) {
                    const sheet = (this.sheetIds[event.payload.id] =
                        new (this.getWindow().CSSStyleSheet)());
                    sheet.replaceSync(rules);
                    elm.adoptedStyleSheets.push(sheet);
                }
                else {
                    elm.setAttribute("type", "text/css");
                    elm.appendChild(document.createTextNode(this.replaceStyleUrls(rules, event.payload.href)));
                }
            } /*  else {
              console.warn("StyleSheet not found", event, elm);
            } */
        });
    }
    handleCanvasImage(event) {
        return __awaiter(this, void 0, void 0, function* () {
            // at some point it was rendered as img
            const canvas = this.idp.getNode(event.payload.target);
            const imageData = this.popAttachment(event.payload.attachment);
            if (!imageData) {
                console.warn("Image attachment for canvas not found.", event.payload);
            }
            else if (!canvas) {
                console.warn("Canvas image target is undefined.", event.payload);
            }
            else if (canvas.tagName === "IMG" || canvas.tagName === "CANVAS") {
                canvas.width = event.payload.width;
                canvas.height = event.payload.height;
                canvas.style.backgroundRepeat = "no-repeat";
                canvas.style.backgroundImage = `url(data:${event.payload.format};base64,${imageData})`;
            }
            else {
                console.warn("Canvas image target is not a canvas.", event.payload);
            }
        });
    }
    handleMutations(event) {
        var _a, _b;
        const muts = event.payload;
        if ((_a = muts.nodes) === null || _a === void 0 ? void 0 : _a.remove) {
            muts.nodes.remove.forEach((id) => {
                const node = this.idp.getNode(id);
                if (node === null || node === void 0 ? void 0 : node.childNodes.length) {
                    new Walker(node).sprint((n) => this.idp.removeNode(n));
                }
                node === null || node === void 0 ? void 0 : node.remove();
            });
        }
        if ((_b = muts.nodes) === null || _b === void 0 ? void 0 : _b.insert) {
            for (const frag of muts.nodes.insert) {
                const insert = this.createFragment(frag);
                if (insert)
                    this.insertFragment(...insert);
            }
        }
        if (muts.attributes) {
            for (const id in muts.attributes) {
                const elm = this.idp.getNode(+id);
                if (elm) {
                    try {
                        // quick workaround till we better handle url changes
                        if (elm.tagName === "IFRAME" && muts.attributes[id].src) {
                            delete muts.attributes[id].src;
                        }
                    }
                    catch (_c) { }
                    for (const name in muts.attributes[id]) {
                        try {
                            if (muts.attributes[id][name] === null) {
                                elm.removeAttribute(name);
                            }
                            else {
                                elm.setAttribute(name, this.transformAttributeValue(elm.tagName, name, muts.attributes[id][name]));
                            }
                        }
                        catch (_d) { }
                    }
                    // some frameworks will override input value setter and will then change the attribute
                    if (elm.tagName === "INPUT" && "value" in muts.attributes[id]) {
                        elm.value = muts.attributes[id].value;
                    }
                    else if (elm.tagName === "DIALOG") {
                        this.pendingDialogNodes.push(elm);
                    }
                }
            }
        }
        if (muts.iframe) {
            for (const id in muts.iframe) {
                const elm = this.idp.getNode(+id);
                const currentSrc = elm.src;
                const src = muts.iframe[id].src;
                const mode = muts.iframe[id].mode;
                if (elm) {
                    elm.removeAttribute("data-ispdf");
                    if (mode === "pdf") {
                        const newSrc = this.replaceAttributeUrl(src);
                        console.log(currentSrc, newSrc);
                        if (currentSrc !== newSrc) {
                            elm.setAttribute("data-ispdf", "");
                            elm.setAttribute("src", newSrc);
                        }
                    }
                    else if (mode === "cross-origin") {
                        const newSrc = new URL(`/cobrowser/public/cross-origin?${src}`, location.origin).href;
                        console.log(currentSrc, newSrc);
                        if (currentSrc !== newSrc)
                            elm.setAttribute("src", newSrc);
                    }
                    else {
                        const newSrc = new URL("/cobrowser/public/remote/" + id, location.origin).toString();
                        console.log(currentSrc, newSrc);
                        if (currentSrc !== newSrc)
                            elm.setAttribute("src", newSrc);
                    }
                }
            }
        }
        if (muts.styles) {
            for (const id in muts.styles) {
                const elm = this.idp.getNode(+id);
                if (elm) {
                    for (const name in muts.styles[id]) {
                        elm.style.setProperty(name, muts.styles[id][name]);
                    }
                }
            }
        }
        if (muts.values) {
            for (const id in muts.values) {
                const elm = this.idp.getNode(+id);
                if (elm) {
                    elm.textContent = muts.values[id];
                }
            }
        }
    }
    createNodeV3(data, parent) {
        var _a;
        switch (data.name) {
            case "#comment":
                return this.getDocument().createComment("");
            case "#document-fragment": {
                const shadow = parent === null || parent === void 0 ? void 0 : parent.attachShadow({ mode: "open" });
                this.input.track(shadow);
                this.cursor.track(shadow);
                return shadow;
            }
            case "#text":
                return this.getDocument().createTextNode(data.text);
            default: {
                const namespaced = data.ns && data.ns !== "html";
                const tagName = data.filter === FilterType.Display ? "DIV" : data.name;
                if (tagName.includes("-") &&
                    !this.ignoreTags.has(tagName) &&
                    this.getWindow().customElements.get(tagName.toLowerCase()) ===
                        undefined) {
                    try {
                        this.getWindow().customElements.define(tagName.toLowerCase(), 
                        // cannot use same class for all
                        class extends this.getWindow().HTMLElement {
                            constructor() {
                                super();
                            }
                        });
                    }
                    catch (_b) {
                        this.ignoreTags.add(tagName);
                    }
                }
                const elm = namespaced
                    ? document.createElementNS(namespaces[data.ns], tagName)
                    : document.createElement(tagName);
                if (data.attrs) {
                    this.transformAttributes(data.name, data.attrs);
                    for (const name in data.attrs) {
                        try {
                            elm.setAttribute(name, data.attrs[name]);
                        }
                        catch (_c) { }
                    }
                }
                if (data.name === "IFRAME" && ((_a = data.attrs) === null || _a === void 0 ? void 0 : _a["data-ispdf"])) {
                    try {
                        elm.setAttribute("src", this.replaceAttributeUrl(data.attrs.src));
                    }
                    catch (ex) {
                        log(ex);
                    }
                }
                else if (data.name === "IFRAME") {
                    if (data.attrs.srcdoc) {
                        // TODO: why not remove?
                        elm.setAttribute("srcdoc", "");
                    }
                    // lazy loading resets the page to blank
                    elm.removeAttribute("loading");
                    elm.setAttribute("src", new URL(`/cobrowser/public/cross-origin?${data.attrs.src}`, location.origin).href);
                    elm.addEventListener("load", () => {
                        const doc = elm.contentDocument;
                        const crossIframe = doc === null || doc === void 0 ? void 0 : doc.getElementById("cross-origin-iframe");
                        const link = doc.querySelector("header a");
                        if (data.attrs.src) {
                            if (crossIframe) {
                                try {
                                    const url = new URL(data.attrs.src);
                                    if (url.hostname.endsWith("youtube.com") ||
                                        url.hostname.endsWith("youtu.be")) {
                                        crossIframe.setAttribute("sandbox", "allow-scripts allow-same-origin allow-presentation");
                                    }
                                }
                                catch (_a) { }
                                crossIframe.src = data.attrs.src;
                                crossIframe.style.display = "block";
                            }
                            if (link) {
                                link.href = data.attrs.src;
                            }
                        }
                        setTimeout(() => {
                            var _a;
                            if (doc === null || doc === void 0 ? void 0 : doc.isConnected)
                                (_a = doc
                                    .getElementsByTagName("header")[0]) === null || _a === void 0 ? void 0 : _a.removeAttribute("hidden");
                        }, 4000);
                    }, { once: true });
                }
                else if (data.name === "NOSCRIPT") {
                    elm.style.display = "none";
                }
                else if (data.name === "META" && "charset" in data.attrs) {
                    elm.setAttribute("charset", "utf-8");
                }
                if (data.sheet) {
                    elm.setAttribute("type", "text/css");
                    elm.appendChild(document.createTextNode(this.replaceStyleUrls(data.sheet.rules, data.sheet.href)));
                }
                return elm;
            }
        }
    }
    createNodeTree(tree, nodes, parent, exclude) {
        var _a;
        const hasChildren = Array.isArray(tree);
        const id = hasChildren ? tree[0] : tree;
        const data = nodes[id];
        let node;
        if (exclude === null || exclude === void 0 ? void 0 : exclude.has(data.id)) {
            // for reference purposes, deleted later
            node = this.getDocument().createComment("");
            const info = this.idp.set(node, data.id);
            info.filter = data.filter;
        }
        else {
            node = this.createNodeV3(data, parent);
            const info = this.idp.set(node, data.id);
            info.filter = data.filter;
            if (hasChildren) {
                for (let i = 1; i < tree.length; i++) {
                    node.appendChild(this.createNodeTree(tree[i], nodes, node, exclude));
                }
            }
            if (data.filter === FilterType.Display) {
                this.pendingFilteredNodes.push(node);
            }
            else if (data.filter === FilterType.DisplayRandomized) {
                switch (data.name) {
                    case "#text":
                        node.nodeValue = randomizeText(node.nodeValue);
                        break;
                    case "INPUT":
                    case "TEXTAREA":
                    case "SELECT":
                        node.setAttribute("disabled", "true");
                        break;
                    case "IMG":
                        node.setAttribute("src", Transparent1px);
                    // eslint-disable-next-line no-fallthrough
                    case "CANVAS":
                        node.style.backgroundColor = "#777";
                        node.style.backgroundRepeat = "no-repeat";
                        break;
                }
                // first such filtered element in the tree
                if (!((_a = getAttachment(parent)) === null || _a === void 0 ? void 0 : _a.filter)) {
                    this.pendingFilteredNodes.push(node);
                    node.setAttribute("inert", "true");
                    node.style.filter = "blur(4px)";
                }
            }
            if (node.nodeName === "DIALOG" && node.open) {
                node.removeAttribute("open");
                this.pendingDialogNodes.push(node);
            }
        }
        return node;
    }
    createFragment(frag, exclude) {
        var _a;
        const parent = this.idp.getNode(frag.parent);
        if (parent &&
            (parent.nodeType === parent.ELEMENT_NODE ||
                parent.nodeType === parent.DOCUMENT_NODE ||
                parent.nodeType === parent.DOCUMENT_FRAGMENT_NODE)) {
            const fragment = this.getDocument().createDocumentFragment();
            for (const subtree of frag.tree) {
                const node = this.createNodeTree(subtree, frag.nodes, parent, exclude);
                if (node.nodeType !== document.DOCUMENT_FRAGMENT_NODE)
                    fragment.appendChild(node);
            }
            if (parent.nodeType === parent.DOCUMENT_NODE) {
                // documentElement might have already been removed by previous mutations list
                (_a = parent.documentElement) === null || _a === void 0 ? void 0 : _a.remove();
            }
            return [parent, fragment, frag.next];
        }
    }
    handleRemoteNavigation(ev) {
        var _a, _b;
        this.url.base = ev.payload.base;
        this.url.href = ev.payload.href;
        if (ev.payload.synthetic !== true && this.isRoot) {
            (_b = (_a = this.handlers).navigation) === null || _b === void 0 ? void 0 : _b.call(_a, { href: this.url.href });
        }
    }
    handleRemoteResize(ev) {
        var _a, _b;
        (_b = (_a = this.handlers).resize) === null || _b === void 0 ? void 0 : _b.call(_a, ev.payload);
    }
    trackFrame(iframe) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!iframe.contentDocument) {
                return;
            }
            const page = new MirrorPage({ target: iframe, compressionSupport: this.options.compressionSupport }, this, this.handlers, this.root);
            page.setEvents({
                input: this.input.enabled || undefined,
                scroll: this.scroll.enabled || undefined,
                cursor: this.cursor.enabled || undefined,
                highlight: this.highlighter.enabled || undefined,
            });
            page
                .getWindow()
                .addEventListener("pagehide", () => this.untrackFrame(iframe));
            this.frames.push(page);
        });
    }
    transformAttributeValue(nodeName, key, value) {
        return nodeName === "A" || nodeName === "IFRAME" || nodeName === "use"
            ? value
            : key === "href" || key === "src"
                ? this.replaceAttributeUrl(value)
                : key === "style"
                    ? this.replaceStyleUrls(value)
                    : value;
    }
    transformAttributes(nodeName, attrs) {
        if (nodeName === "A" || nodeName === "IFRAME" || nodeName === "use") {
            return;
        }
        try {
            if ("href" in attrs) {
                attrs.href = this.replaceAttributeUrl(attrs.href);
            }
            if ("src" in attrs) {
                attrs.src = this.replaceAttributeUrl(attrs.src);
            }
        }
        catch (ex) {
            log(ex, attrs, nodeName);
        }
        try {
            if ("style" in attrs) {
                attrs.style = this.replaceStyleUrls(attrs.style);
            }
        }
        catch (ex) {
            log(ex, attrs, nodeName);
        }
    }
    replaceAttributeUrl(value) {
        if (value.startsWith("http") || value.startsWith("data:")) {
            return value;
        }
        const absoluteUrl = new URL(this.url.base, this.url.href).href;
        return new URL(value, absoluteUrl).href;
    }
    replaceStyleUrls(styles, href) {
        const regex = /url\(['"]?([^'")]+)['"]?\)/gm;
        let absoluteUrl = this.url.base
            ? new URL(this.url.base, this.url.href).href
            : this.url.href;
        if (href) {
            absoluteUrl = new URL(href, absoluteUrl).href;
        }
        return styles
            ? styles.replace(regex, (match, p1) => !p1 || p1.startsWith("http") || p1.startsWith("data:")
                ? match
                : `url('${new URL(p1, absoluteUrl).href}')`)
            : "";
    }
    flush() {
        return __awaiter(this, arguments, void 0, function* (lite = false) {
            const events = this.queue
                .concat(...(yield Promise.all(this.frames.map((frame) => frame.flush()))))
                .sort((a, b) => a.time - b.time);
            this.queue = [];
            if (!events.length) {
                return [];
            }
            else if (this.isRoot) {
                return [
                    {
                        type: "Batch",
                        time: this.getTime(),
                        count: this.ecounter++,
                        document: this.documentId,
                        payload: { format: "json", events },
                    },
                ];
            }
            else {
                return events;
            }
        });
    }
}
